import { IRoleItemViewModel } from "../../../model/respone/user/IRole";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eRoleActionTypeIds {
    LOAD_START = "Role_LOAD_START",
    LOAD_SUCCESS = "Role_LOAD_SUCCESS",
    LOAD_ERROR = "Role_LOAD_ERROR"
}
export interface IRoleLoadStart extends IActionTypeBase<eRoleActionTypeIds.LOAD_START, undefined> { }
export interface IRoleLoadSuccess extends IActionTypeBase<eRoleActionTypeIds.LOAD_SUCCESS, IRoleItemViewModel[]> { }
export interface IRoleLoadError extends IActionTypeBase<eRoleActionTypeIds.LOAD_ERROR, string | undefined> { }

export type IRoleActionTypes = IRoleLoadStart | IRoleLoadSuccess | IRoleLoadError